import React from "react";
import "./index.scss";

const classPrefix = "yfm-product-detail-linking-process-skeleton";

const LinkingProcessSkeleton: React.FC = () => {
  return (
    <div className={`${classPrefix}`}>
      <div className={`${classPrefix}__title-box`}>
        <span className="yfm-is-skeleton">Linking Process</span>
      </div>
      <div className={`${classPrefix}__content-box yfm-is-skeleton`}></div>
    </div>
  );
};

export default LinkingProcessSkeleton;
